import { useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import CompanyLayoutContext from "@/model/CompanyLayoutContext";
import UserProfileResponse from "@/model/UserProfileResponse";
import CompanyUsersPanel from "@/components/CompanyUsersPanel/CompanyUsersPanel";

function CompanyUsersTab() {
  const { id } = useParams<{ id: string }>();
  const { company } = useOutletContext<CompanyLayoutContext>();
  const [users, setUsers] = useState<UserProfileResponse[]>(
    company.users ?? []
  );

  if (!id) {
    return null;
  }

  return (
    <CompanyUsersPanel companyId={id} users={users} onUsersChange={setUsers} />
  );
}

export default CompanyUsersTab;
